import {IOrganization} from "../IOrganization";
import {
    Button,
    Checkbox,
    FormControlLabel,
    Grid,
    MenuItem,
    Select,
    SelectChangeEvent,
    Switch,
    TextField
} from "@mui/material";
import {Delete as DeleteIcon} from "@mui/icons-material"
import React from "react";


import {IOrganizationPartners} from "./PublisherLogins.container";
import {SmartSelect, FormChips} from "@leap4/frontend";


interface IPublisherLoginsAccessProps {
    organization: IOrganizationPartners,
    isLoading: boolean,
    availableOrganizations: Array<IOrganization>,
    onUpdateSelectedOrgs: (selectedOrg: string, currentOrgId: string | undefined) => void,
    onPartnersChange: (choosenPartners: string[], currentOrgId: string) => void,
    onSkipDiscChange: (toSkipDiscrepancy: boolean, currentOrgId: string) =>void,
    onOrganizationRemove: (selectedOrg: string | undefined) => void,

}

export const PublisherLoginsAccess = ({
                                          organization,
                                          isLoading,
                                          availableOrganizations,
                                          onUpdateSelectedOrgs,
                                          onPartnersChange,
                                          onOrganizationRemove,
    onSkipDiscChange
                                      }: IPublisherLoginsAccessProps) => {

    const {org, selectedPartners,optionalPartners} = organization
    const handleOrgChange = ({target}: SelectChangeEvent) => {
        const currentOrgId = org?._id
        onUpdateSelectedOrgs(target.value, currentOrgId)
    }
    const handlePartnersChange = (choosenPartners: string[]) => {
        onPartnersChange(choosenPartners, org._id)
    }
    const handleOrganizationRemove = () => {
        onOrganizationRemove(org._id)
    }

    const handleSkipDiscChange = (e: any) =>{
        onSkipDiscChange(e.target.checked, org._id)
    }


    return (
        <Grid container xs={12}  alignItems={'center'} spacing={3} mb={2}>
            <Grid item xs={2.5} lg={2}>

                <Select size={"small"} disabled={isLoading}
                        onChange={handleOrgChange} value={org?._id || 'NULL'}
                        fullWidth
                >

                    <MenuItem disabled value={'NULL'}>
                        <em>Select Organization</em>
                    </MenuItem>

                    {availableOrganizations.map(o => {
                        return <MenuItem key={o._id} divider value={o?._id || 'ID'}>{o?.name}</MenuItem>
                    })}

                </Select>
            </Grid>


            <Grid item xs={8} lg={6}>

                <FormChips optionsList={optionalPartners} onUpdateItems={handlePartnersChange}
                           inputName={"Supply Partners"}
                           enableCreate={false} chips={selectedPartners}
                           pureCreate={false}
                           textFieldProps={{size: "small", style: {width: "100%"}}}
                           stackProps={{style: {width: "100%"}}}
                           labelKey={"name"}
                           valueKey={"id"}

                />
            </Grid>

            <Grid item xs={1.5} lg={4} container gap={5}>
                <FormControlLabel control={<Checkbox checked={organization.toSkipDiscrepancy} onChange={handleSkipDiscChange}/>} label="Skip Discrepancy"  />
                <Button variant="outlined" disabled={!org?._id} startIcon={<DeleteIcon/>}
                        onClick={handleOrganizationRemove}>
                    Delete
                </Button>
            </Grid>


        </Grid>
    )
}





